import React, {Component} from "react";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {DefaultBtn} from "Ncontracts.Common.UI";
import {imageCdnUrls} from "../../common/ImageCdnUrls";
import {
    CLEAR_RECIPIENT_TYPE_SELECTION,
    TOGGLE_NEW_COMMUNICATION_ADD_RECIPIENTS_MODAL,
    TOGGLE_REPLACE_RECIPIENTS_WARNING
} from "../../../actions/communications/newCommunicationAction";

class NewCommunicationReplaceRecipientsWarning extends Component {

    static propTypes = {
        dismissWarning: PropTypes.func,
        showAddRecipientsModal: PropTypes.func
    };

    constructor(props, context) {
        super(props, context);
    }

    handleYesClick = () => {
        this.props.dismissWarning();
        this.props.showAddRecipientsModal();
    };

    handleNoClick = () => {
        this.props.dismissWarning();
    };

    render() {
        return (
            <div className="modal is-active prompt-modal">
                <div className="modal-background"/>
                <div className="modal-card modal-content">
                    <section className="modal-card-body">
                        <div className="prompt-image has-text-centered">
                            <img src={imageCdnUrls.exclamation_circle} width="50" height="50"/>
                        </div>
                        <div className="prompt-subject has-text-centered">Are you sure?</div>
                        <div className="has-text-centered">
                            Please note that this will replace your current list of recipients.<br/>
                            Are you sure you want to continue?
                        </div>
                    </section>
                    <footer className="modal-card-foot">
                        <div className="modal-footer-buttons has-text-centered">
                            <DefaultBtn onClick={this.handleYesClick}
                                        className="btn--smaller btn--wide">Yes</DefaultBtn>
                            <DefaultBtn onClick={this.handleNoClick}
                                        className="btn--smaller btn--wide">No</DefaultBtn>
                        </div>
                    </footer>
                </div>
            </div>);
    }
}

const mapDispatchToProps = dispatch => ({
    dismissWarning: () => dispatch({type: TOGGLE_REPLACE_RECIPIENTS_WARNING}),
    showAddRecipientsModal: () => {
        dispatch({type: CLEAR_RECIPIENT_TYPE_SELECTION});
        dispatch({type: TOGGLE_NEW_COMMUNICATION_ADD_RECIPIENTS_MODAL});
    }
});

export default withRouter(connect(null, mapDispatchToProps)(NewCommunicationReplaceRecipientsWarning));
